module.exports = __webpack_public_path__ + "img/colegio.9891b0f5.jpg";